module.exports = __webpack_public_path__ + "img/coins.c495735b.png";